import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const MFASetupPage: React.FC = () => {
  const [mfaToken, setMfaToken] = useState('');
  const { verifyMFA, tempToken, loading, error } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (tempToken && mfaToken.length === 6) {
      const success = await verifyMFA(tempToken, mfaToken);
      if (success) {
        navigate('/chat');
      }
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #10a37f 0%, #0d8f6f 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1.5rem'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '450px'
      }}>
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '1rem',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
          padding: '3rem',
          border: '1px solid #f0f0f0'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <div style={{
              width: '80px',
              height: '80px',
              backgroundColor: '#f0f9ff',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1.5rem',
              fontSize: '2rem'
            }}>
              🛡️
            </div>
            <h1 style={{
              fontSize: '1.875rem',
              fontWeight: 800,
              color: '#2d333a',
              marginBottom: '0.5rem'
            }}>
              Two-Factor Authentication
            </h1>
            <p style={{ color: '#6e7681', fontSize: '1rem' }}>
              Enter the 6-digit code from your authenticator app
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{
                display: 'block',
                fontSize: '0.875rem',
                fontWeight: 500,
                color: '#2d333a',
                marginBottom: '0.5rem'
              }}>
                Authentication Code
              </label>
              <input
                type="text"
                value={mfaToken}
                onChange={(e) => setMfaToken(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="000000"
                maxLength={6}
                style={{
                  width: '100%',
                  padding: '1rem',
                  border: '1px solid #e5e5e5',
                  borderRadius: '0.5rem',
                  backgroundColor: '#ffffff',
                  color: '#2d333a',
                  fontSize: '1.5rem',
                  textAlign: 'center',
                  letterSpacing: '0.5rem',
                  fontFamily: 'monospace'
                }}
              />
            </div>

            {error && (
              <div style={{
                padding: '0.75rem',
                backgroundColor: '#fef2f2',
                border: '1px solid #fecaca',
                borderRadius: '0.5rem',
                color: '#dc2626',
                fontSize: '0.875rem',
                marginBottom: '1.5rem'
              }}>
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading || mfaToken.length !== 6}
              style={{
                width: '100%',
                padding: '1rem 1.5rem',
                border: 'none',
                borderRadius: '0.5rem',
                backgroundColor: loading || mfaToken.length !== 6 ? '#8e9297' : '#10a37f',
                color: 'white',
                fontSize: '1rem',
                fontWeight: 600,
                cursor: loading || mfaToken.length !== 6 ? 'not-allowed' : 'pointer',
                transition: 'all 0.15s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                marginBottom: '1.5rem'
              }}
            >
              {loading ? (
                <>
                  <div className="spinner" />
                  Verifying...
                </>
              ) : (
                'Verify Code'
              )}
            </button>
          </form>

          <div style={{ textAlign: 'center' }}>
            <p style={{ color: '#6e7681', fontSize: '0.875rem', marginBottom: '1rem' }}>
              Having trouble?
            </p>
            <button
              onClick={() => {/* Implement resend logic */}}
              style={{
                background: 'none',
                border: 'none',
                color: '#10a37f',
                fontSize: '0.875rem',
                cursor: 'pointer',
                textDecoration: 'underline',
                marginRight: '1rem'
              }}
            >
              Use backup code
            </button>
            <button
              onClick={() => navigate('/login')}
              style={{
                background: 'none',
                border: 'none',
                color: '#6e7681',
                fontSize: '0.875rem',
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
            >
              Back to login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MFASetupPage;
